import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ColumnChartService {

    makeOptions(chart, data) {
        const options = {
            theme: 'light',
            autoGridCount: false,
            gridCount: data.length,
            type: chart.type ? chart.type : 'serial',
            startDuration: 0,
            dataProvider: data,
            fontFamily: chart.font.family ? chart.font.family : 'latolight',
            fontSize: chart.font.size ? chart.font.size : 12,
            color: chart.color ? chart.color : '#666666',
            opacity: chart.opacity,
            titles: [{
                text: chart.title ? chart.title : '',
                empty: chart.emptyText ? chart.emptyText : '',
                color: chart.font.color ? chart.font.color : '#666666',
            }],
            valueAxes: [{
                position: 'left',
                labelsEnabled: chart.axis.y.labelsEnabled,
                labelFunction: (value, valueText, valueAxis) => {
                    if (chart.axis.y.hasOwnProperty('labelFormat')) {
                        return `${valueText} ${chart.axis.y.labelFormat}`;
                    }
                    return valueText;
                },
                title: chart.axis.y.title,
                minimum: chart.axis.y.min,
                maximum: chart.axis.y.max,
                fontSize: chart.axis.y.fontSize ? chart.axis.y.fontSize : 12,
                guides: chart.axis.y.guides ? this.getAxisGuides(
                    'y', chart.axis.y.guides, this.getMedian(data, chart.axis.y.guides.me)
                ) : []
            }],
            graphs: [
                {
                    balloonText: '',
                    fillColorsField: 'color',
                    fillAlphas: 1,
                    lineAlpha: 0.1,
                    type: 'column',
                    valueField: chart.axis.y.value,
                    title: chart.axis.y.title
                },
                {
                    bullet: 'round',
                    balloonText: chart.balloonText ? chart.balloonText : '[[category]]: <b>[[value]]</b>',
                    bulletBorderAlpha: 1,
                    bulletColor: '#FFFFFF',
                    bulletSize: 7,
                    lineThickness: 2,
                    title: chart.axis.y.title,
                    type: 'smoothedLine',
                    useLineColorForBulletBorder: true,
                    valueField: chart.axis.y.value
                }
            ],
            chartCursor: {
                categoryBalloonEnabled: false,
                cursorAlpha: 0,
                zoomable: false
            },
            rotate: chart.rotate ? chart.rotate : false,
            categoryField: chart.axis.x.value,
            categoryAxis: {
                title: chart.axis.x.title,
                color: '#000000',
                fontSize: chart.axis.x.fontSize ? chart.axis.x.fontSize : 12,
                gridPosition: 'start',
                gridAlpha: 0,
                labelsEnabled: chart.axis.x.labelsEnabled,
                inside: chart.axis.x.inside ? chart.axis.x.inside : false,
                labelRotation: chart.axis.x.labelRotation ? chart.axis.x.labelRotation : 0,
                labelFunction: (valueText, serialDataItem, categoryAxis) => {
                    if (serialDataItem.dataContext.hasOwnProperty('labelOffset')) {
                        categoryAxis.labelOffset = serialDataItem.dataContext.labelOffset;
                    }
                    return valueText;
                },
                guides: chart.axis.x.guides ? this.getAxisGuides(
                    'x', chart.axis.x.guides, this.getMedian(data, chart.axis.x.guides.me)
                ) : []
            }
        };

        if (chart.hasOwnProperty('colors')) {
            options['colors'] = chart.colors;
        }

        if (chart.axis.y.hasOwnProperty('labelFunction')) {
            options.valueAxes['labelFunction'] = chart.axis.y.labelFunction;
        }
        return options;
    }

    getAxisGuides(axis, { label, position, inside }, median) {
        const guides = {
            above: true,
            lineAlpha: 1,
            fillAlpha: 0.2,
            position: position ? position : 'left',
            dashLength: 2,
            inside: inside ? inside : true,
            labelRotation: 90,
            boldLabel: true,
            fontSize: 14,
            color: '#333232',
            label: `${label} ${median.label}`
        };
        if (axis === 'y') {
            guides['value'] = median.min;
            guides['toValue'] = median.max;
        } else {
            guides['category'] = median.min;
            guides['toCategory'] = median.max;

        }
        return [guides];
    }

    calcMedian({ data, totalItems }) {
        let me = 0;
        if (totalItems > 0) {
            const isEven = (totalItems % 2) === 0;
            if (isEven) {
                const x1 = totalItems / 2;
                const x2 = x1 + 1;
                const value1 = data[x1 - 1];
                const value2 = data[x2 - 1];
                me = (value1 + value2) / 2;
            } else {
                const x = (totalItems + 1) / 2;
                const value = data[x - 1];
                me = value;
            }
        }
        return me;
    }

    getMedian(chartData, chartMedianData) {
        let me = this.calcMedian(chartMedianData);
        me = +me.toFixed(1);

        const median = {
            label: me,
            min: me,
            max: Math.round(me)
        };

        if (!this.checkMedianExists(chartData, me)) {
            const data = this.getMedianRange(chartMedianData, me);
            median.min = data.min;
            median.max = data.max;
        }

        return median;
    }

    getMedianRange(chartMedianData, me) {
        let min = 0;
        let max = 0;
        let prev = 0;
        chartMedianData.data.map(item => {
            const cur = item;
            if (me >= prev && me <= cur) {
                min = prev;
                max = cur;
            }
            prev = cur;
        });

        return {
            min: min,
            max: Math.round(max)
        };
    }

    checkMedianExists(chartData, me) {
        const meExists = chartData ? chartData.filter(({ points }) => points === me) : [];
        return meExists.length;
    }

    handleDataProvided(AmCharts) {
        AmCharts.addInitHandler(chart => {
            if (chart.dataProvider.length === 0 || chart.dataProvider === undefined) {
                const dataPoint = {
                    dummyValue: 0
                };

                dataPoint[chart.categoryField] = '';
                chart.dataProvider = [dataPoint];
                chart.chartDiv.style.opacity = chart.opacity;
                chart.addLabel(0, '50%', chart.titles[0].empty, 'center');
            }
        }, ['serial']);
    }
}
